import BaseCRUDReducer from './CRUDReducer';
import { VideoCategoryActions } from '../actions/video-categories';

const CRUDReducer = new BaseCRUDReducer(new VideoCategoryActions());

export default (state, action) => CRUDReducer.run(state, action);



// WEBPACK FOOTER //
// ./src/reducers/video-categories.js